import { useAuthStore } from "@/store/authStore";

/**
 * Returns true if the current user has the given permission code, or is GOD.
 * Uses the roles[] embedded in the JWT (and surfaced via /me).
 */
export function usePermission(code: string): boolean {
  const me = useAuthStore((s) => s.me);
  if (!me) return false;
  if (me.is_god) return true;
  for (const r of me.roles) {
    if (r.permissions.includes(code)) return true;
  }
  return false;
}

export function useAnyPermission(codes: string[]): boolean {
  const me = useAuthStore((s) => s.me);
  if (!me) return false;
  if (me.is_god) return true;
  for (const r of me.roles) {
    for (const c of codes) {
      if (r.permissions.includes(c)) return true;
    }
  }
  return false;
}
